import type { HTMLAttributes } from "react";
import { cn } from "../utils/cn.js";

type Size = "sm" | "md" | "lg" | "xl" | "full";

const widths: Record<Size, string> = {
  sm:   "max-w-3xl",
  md:   "max-w-5xl",
  lg:   "max-w-6xl",  // ≈ 1200px content width (brand spec)
  xl:   "max-w-7xl",
  full: "max-w-none",
};

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  size?: Size;
}

/** Centered, gutter-padded wrapper. 20px gutters mobile, 40px desktop. */
export const Container = ({ size = "lg", className, children, ...rest }: ContainerProps) => (
  <div
    className={cn(
      "mx-auto w-full px-5 md:px-10",
      widths[size],
      className,
    )}
    {...rest}
  >
    {children}
  </div>
);
